<!-- Flexible info card using content projection and CSS for reversed layout -->
<section class="bg-white rounded-lg shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-300">
  
  <!-- Optional card title projection -->
  <ng-content select="[card-title]"></ng-content>
  
  <!-- Main card layout with CSS-controlled direction -->
  <div class="grid lg:grid-cols-2" [class.lg:flex-row-reverse]="reversed()">
    
    <!-- Left content slot (main content) -->
    <div class="p-8 order-2" [class.order-1]="reversed()">
      <!-- Card header slot -->
      <div class="mb-8">
        <ng-content select="[card-header]"></ng-content>
      </div>
      
      <!-- Main content slot -->
      <div class="mb-8">
        <ng-content select="[card-content]"></ng-content>
      </div>
      
      <!-- Additional content slot (for time/location boxes etc.) -->
      <ng-content select="[card-extra]"></ng-content>
    </div>
    
    <!-- Right content slot (details/sidebar) -->
    <div class="bg-gradient-to-br from-brand-goldline/10 to-brand-nude/20 p-8 flex items-center order-1" [class.order-2]="reversed()">
      <div class="w-full">
        <ng-content select="[card-sidebar]"></ng-content>
      </div>
    </div>
    
  </div>
  
</section>